import { Action } from '@ngrx/store';
import {HardwareFaultLevels} from '../../../models/events';

export enum HardwareFaultLevelActionTypes {
  LoadHardwareFaultLevels = '[HardwareFaultLevel] Load HardwareFaultLevels',
  GetHardwareFaultLevels = '[HardwareFaultLevel] Get HardwareFaultLevels',
  GetHardwareFaultLevelFails = '[HardwareFaultLevel] Get HardwareFaultLevelFails'
}

export class GetHardwareFaultLevels implements Action {
  readonly type = HardwareFaultLevelActionTypes.GetHardwareFaultLevels;
  constructor(public payload: any = null) {}
}

export class LoadHardwareFaultLevels implements Action {
  readonly type = HardwareFaultLevelActionTypes.LoadHardwareFaultLevels;
  constructor(public payload: HardwareFaultLevels[]) {}
}

export class GetHardwareFaultLevelFails implements Action {
  readonly type = HardwareFaultLevelActionTypes.GetHardwareFaultLevelFails;
}


export type HardwareFaultLevelActions = LoadHardwareFaultLevels
  | GetHardwareFaultLevels
  | GetHardwareFaultLevelFails;
